import axios from "axios";

const BASE_API_URL = "/api/v1";
const API_PREFIX_TO_STRIP = "http://staging-api.ailingua.net/api/v1";

async function getVideoLessons({ categories = [], levels = [] } = {}) {
  const params = new URLSearchParams();
  if (categories.length > 0) {
    params.append("categories", categories.join(","));
  }
  if (levels.length > 0) {
    params.append("levels", levels.join(","));
  }

  const results = [];
  let nextUrl = `${BASE_API_URL}/videoLesson/?${params.toString()}`;

  try {
    while (nextUrl) {
      const response = await axios.get(nextUrl, { withCredentials: true });

      if (response.data?.results?.length) {
        results.push(...response.data.results);
      }

      const fullNextUrl = response.data.next;
      if (fullNextUrl) {
        const relativeUrl = fullNextUrl.replace(API_PREFIX_TO_STRIP, "");
        nextUrl = `${BASE_API_URL}${relativeUrl}`;
      } else {
        nextUrl = null;
      }
    }
    console.log("results", results);

    return { results };
  } catch (error) {
    console.error("❌ Error fetching video lessons:", error);
    throw new Error(
      error.response?.data?.message || "Failed to fetch video lessons."
    );
  }
}

async function getVideoLessonProgress(id) {
  try {
    const response = await axios.get(`${BASE_API_URL}/videoLesson/${id}/progress/`, {
      withCredentials: true,
    });
    return response.data;
  } catch (error) {
    console.error("❌ Error fetching lesson progress:", error);
    return null;
  }
}

async function getVideoLessonById(id) {
  try {
    const response = await axios.get(`${BASE_API_URL}/videoLesson/${id}/`, {
      withCredentials: true,
    });

    return response.data;
  } catch (error) {
    console.error(`Error fetching video lesson with id ${id}:`, error);
    throw new Error(
      error.response?.data?.message ||
        `Failed to fetch video lesson with id ${id}.`
    );
  }
}

/**
 * Mark a section as completed for a video lesson
 * @param {number} videoLessonId - The video lesson ID
 * @param {string} section - Section name (e.g. "video", "words", "quiz")
 * @param {string} status - Status value ("completed" or "not_started")
 */
async function markSectionCompleted(videoLessonId, section = "video", status = "completed") {
  try {
    const response = await axios.post(
      `${BASE_API_URL}/videoLesson/${videoLessonId}/section-progress/`,
      { section, status },
      { withCredentials: true }
    );
    return response.data;
  } catch (error) {
    console.error(`Error marking section '${section}' as ${status} for lesson ${videoLessonId}:`, error);
    throw error;
  }
}

export { getVideoLessons, getVideoLessonById, getVideoLessonProgress, markSectionCompleted };
